import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { ErrorHandlerService } from '../../services';
var NotifyAttendeesComponent = /** @class */ (function () {
    function NotifyAttendeesComponent(data, dashboardService, errorHandlerService, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.specifyuser = false;
        this.userToresults = [];
        this.usersTo = [];
        this.invitedata = {};
        this.messageto = [];
        this.msgTitle = "";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.msgContent = "";
        this.popUp = false;
        this.subscriptions = [];
        this.id = 0;
    }
    NotifyAttendeesComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    NotifyAttendeesComponent.prototype.editDisplayInline = function (edit) {
        if (edit) {
            return "inline-block";
        }
        else {
            return "none";
        }
    };
    NotifyAttendeesComponent.prototype.handleChange1 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = false;
        }
    };
    NotifyAttendeesComponent.prototype.handleChange2 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = true;
        }
    };
    NotifyAttendeesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            _this.id = params['id'];
            console.log(_this.id);
        });
    };
    NotifyAttendeesComponent.prototype.submit = function () {
        var _this = this;
        var arrTo = [];
        // this.messageto.forEach(element => {
        // arrTo.push(element.emailId);
        //});
        this.invitedata.emailIds = arrTo;
        this.invitedata.courseId = this.id;
        this.invitedata.subject = "Notification from tutor";
        this.invitedata.isInviteAttendeeInMyNetowrk = false;
        this.invitedata.url = process.env.HOST_URL + "?accessPage=public/viewsession?sessionId=" + this.id;
        var s1 = this.dashboardService.courseNotification(this.invitedata).subscribe(function (data) {
            console.log(data);
            _this.msgTitle = "Success";
            _this.msgContent = "Notification Sent!!";
            _this.popUp = true;
            _this.messageto = [];
            _this.invitedata = {};
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    NotifyAttendeesComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    NotifyAttendeesComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    NotifyAttendeesComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return NotifyAttendeesComponent;
}());
export { NotifyAttendeesComponent };
//# sourceMappingURL=notifyattendees.component.js.map